var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      attrs: {
        content: _vm.isEdit
          ? _vm.$t("SeaExport.copyAndAddPoItems")
          : _vm.$t("SeaExport.View")
      }
    },
    [
      _c("i", {
        staticClass: "el-icon-document-copy",
        staticStyle: { cursor: "pointer", "font-size": "18px" },
        on: { click: _vm.onClick }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }